/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { CustomLocaleObject, setLocale } from 'yup';

import i18n from '../i18n/i18n';

type MessageParams = {
  path: string;
  value: any;
  originalValue: any;
  label: string;
  type: string;
  values?: any;
  resolved?: Array<any>;
}

const I18N_TYPE_NS = 'type';
export const translateYupMessage = (key: string, keys: object = {}, ns = 'validation') => i18n.t(key, { ns, ...keys });

export const applyCustomYupMessages = () => {
  const customMessages: CustomLocaleObject = {
    mixed: {
      default: () => translateYupMessage('field.invalid.default'),
      required: () => translateYupMessage('field.required'),
      notType: (msg: MessageParams) => (msg.type === 'number' ? translateYupMessage('field.invalid.number') : msg),
      notEmptyString: () => translateYupMessage('field.required'),
      oneOf: ({ label, values, resolved }: MessageParams) => {
        let keys = '';
        if (label && resolved && resolved?.findIndex((x) => typeof x !== 'string') <= -1) {
          keys = resolved.map((x) => i18n.t(`${label}.${x}`, { ns: I18N_TYPE_NS })).join(', ');
        }
        if (!label || typeof keys !== 'string' || keys.length <= 0) {
          keys = values;
        }
        return translateYupMessage('field.notOneOf', { values: keys })
      }
    },
    number: {
      positive: () => translateYupMessage('field.number.notPositive')
    },
    string: {
      email: () => translateYupMessage('field.invalid.email'),
      // phone: () => translateYupMessage('field.invalid.phone'),
      // min: ({ min }) => translateYupMsg('field.string.tooShort', { min }),
      // max: ({ max }) => translateYupMsg('field.string.tooLong', { max }),
    },
  };

  setLocale(customMessages);
};

/**
 * TODO: Find a better way to apply custom messages for yup
 * https://github.com/jquense/yup/issues/293
 *
 * Some things to know about the setLocale:
 * It needs to be set before your schemas are initialized. (Thats why we call applyCustomYupMessages here before)
 * Therefor setLocale needs to be called before the app.tsx is being touched.
 * To guarantee that this file is called first we make sure that our export of yup in this lib (inside yup.ts)
 * is exported after this file in the index.ts of this lib. And then we need to use the custom export of this lib in our forms instead of the default yup.
 */
applyCustomYupMessages();
